var _rect, _rect2, _rect3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEmail4 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    fill: "#FDECEC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1868_1889",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 21,
    height: 21
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 9.5,
    width: 19.8261,
    height: 19.8261,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1868_1889)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1868_1889",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 18,
    height: 18
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1868_1889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 25C12.5875 25 12.2345 24.8533 11.941 24.5597C11.647 24.2657 11.5 23.9125 11.5 23.5V14.5C11.5 14.0875 11.647 13.7345 11.941 13.441C12.2345 13.147 12.5875 13 13 13H25C25.4125 13 25.7657 13.147 26.0597 13.441C26.3533 13.7345 26.5 14.0875 26.5 14.5V18.775C26.275 18.6625 26.0345 18.5687 25.7785 18.4937C25.522 18.4187 25.2625 18.3625 25 18.325V16L19.3937 19.5063C19.3312 19.5438 19.2655 19.5717 19.1965 19.5903C19.128 19.6092 19.0625 19.6187 19 19.6187C18.9375 19.6187 18.872 19.6092 18.8035 19.5903C18.7345 19.5717 18.6688 19.5438 18.6063 19.5063L13 16V23.5H19C19 23.7625 19.0187 24.0155 19.0562 24.259C19.0938 24.503 19.15 24.75 19.225 25H13ZM19 18.25L25 14.5H13L19 18.25ZM24.25 27.25C23.2125 27.25 22.3282 26.8845 21.5972 26.1535C20.8658 25.422 20.5 24.5375 20.5 23.5C20.5 22.4625 20.8658 21.578 21.5972 20.8465C22.3282 20.1155 23.2125 19.75 24.25 19.75C25.2875 19.75 26.172 20.1155 26.9035 20.8465C27.6345 21.578 28 22.4625 28 23.5C28 24.5375 27.6345 25.422 26.9035 26.1535C26.172 26.8845 25.2875 27.25 24.25 27.25ZM22.375 23.875H26.125C26.225 23.875 26.3125 23.8375 26.3875 23.7625C26.4625 23.6875 26.5 23.6 26.5 23.5C26.5 23.4 26.4625 23.3125 26.3875 23.2375C26.3125 23.1625 26.225 23.125 26.125 23.125H22.375C22.275 23.125 22.1875 23.1625 22.1125 23.2375C22.0375 23.3125 22 23.4 22 23.5C22 23.6 22.0375 23.6875 22.1125 23.7625C22.1875 23.8375 22.275 23.875 22.375 23.875ZM13 23.5V18.25V18.3062V16V16.1875V15.1C13 14.9625 13 14.9625 13 15.1V15.0903V16.1875V16V23.5Z",
    fill: "#CC5C5C"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmail4, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email4.1c17801d.svg";
export { ForwardRef as ReactComponent };